/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
/* eslint-disable no-redeclare */
import { ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { LitElement, css, html, unsafeCSS } from 'lit';

export class Dialog extends LitElement {
  #dialog: HTMLDialogElement;
  static properties = {
    open: { type: Boolean },
    onClose: { type: Function },
    onClosed: { type: Function },
  };

  render() {
    return html`<dialog><slot></slot></dialog>`;
  }

  updated(changed: Map<string, unknown>) {
    if (changed.has('open')) {
      if (this.open) {
        requestAnimationFrame(() => this.#dialog.showModal());
      } else {
        requestAnimationFrame(() => requestAnimationFrame(() => this.#dialog.close()));
      }
    }
  }

  firstUpdated(_) {
    super.firstUpdated(_);
    this.#dialog = this.renderRoot.querySelector('dialog') as HTMLDialogElement;
    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) {
        this.onClose?.();
      }
    });
    this.#dialog.addEventListener('close', () => {
      this.onClosed?.();
    });
  }

  static styles = css`
    :host {
      display: block;
    }
    dialog {
      padding: 0;
      border: none;
      border-radius: ${unsafeCSS(ModalLayoutTokens.Radius())};
      background-color: ${unsafeCSS(ModalLayoutTokens.PaperColor())};
      margin: auto;
      max-width: 100vw;
      max-height: 100dvh;
      box-sizing: border-box;
    }
    dialog > div {
      max-width: 100%;
      max-height: 100%;
      box-sizing: border-box;
    }

    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
    }
  `;

  static register(name = 'yh-dialog') {
    if (!customElements.get(name)) {
      customElements.define(name, Dialog);
    }
  }
}

if (typeof customElements !== 'undefined') {
  Dialog.register();
}
export interface Dialog {
  open: boolean;
  onClose?: () => void;
  onClosed?: () => void;
}
